import { Component as ReactComponent } from 'react';

import { CheckoutField, TextKey } from '@mews-distributor/common';
import { LocalizedText } from '@mews/framework';

import { PaymentCardFormSection } from '../PaymentCardFormSection';

import { PciProxyCardNumber, PciProxyCvv } from './components';
import { CARD_NUMBER_FIELD_ID, CVV_FIELD_ID } from './constants';

const PciProxyServiceContainer = (Component: $TSFixMe) =>
    class extends ReactComponent {
        componentDidMount() {
            (this.props as $TSFixMe).initPciProxyService();
        }

        componentWillUnmount() {
            (this.props as $TSFixMe).tearDownPciProxyService();
        }

        render() {
            return <Component {...this.props} />;
        }
    };

const BasePciProxyPaymentCardFormSection = PaymentCardFormSection({
    renderPaymentCardNumber: () => (
        <PciProxyCardNumber
            // @ts-expect-error $TSFixMeError: Type '{ name: CheckoutField; label: Element; autoComplete: string; id: string; }' is not assignable to type 'IntrinsicAt...
            name={CheckoutField.CardNumber}
            label={<LocalizedText textKey={TextKey.PaymentCardNumber} />}
            autoComplete="cc-number"
            id={CARD_NUMBER_FIELD_ID}
        />
    ),
    renderPaymentCvv: () => (
        <PciProxyCvv
            // @ts-expect-error $TSFixMeError: Type '{ name: CheckoutField; label: Element; id: string; autoComplete: string; }' is not assignable to type 'IntrinsicAt...
            name={CheckoutField.CardCVV}
            label={<LocalizedText textKey={TextKey.PaymentCardCVV} />}
            id={CVV_FIELD_ID}
            autoComplete="cc-csc"
        />
    ),
});

export const PciProxyPaymentCardFormSection = PciProxyServiceContainer(BasePciProxyPaymentCardFormSection);
